<template>
  <div class="flex">
    <svg-icon type="mdi" :path="path"></svg-icon>
  </div>
</template>

<script>

import SvgIcon from '@jamescoyle/vue-icon';
import { mdiArrowTopLeft } from "@mdi/js"

export default {
  name: "ArrowTopLeftIcon",
  components: {
    SvgIcon
  },
  data() {
    return {
      path: mdiArrowTopLeft,
    }
  }
}
</script>
